import { Component, OnInit } from '@angular/core';
import { JobService } from './jobs.service';
import { NotificationService } from './../../shared/services/notification.service';
import { TitleMetadataService } from './../../shared/services/title-metadata.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-jobs',
    templateUrl: './jobs.component.html',
    styleUrls: ['./jobs.component.css'],
    standalone: false
})
export class JobsComponent implements OnInit {
  jobsArray: any;

  constructor(
    private jobService: JobService,
    private router: Router,
    private notificationService: NotificationService,
    private titleService: TitleMetadataService
  ) { }

  ngOnInit() {
    this.titleService.createCanonicalURL(this.router.url);
    this.getJobs();
  }

  // Get -  JOBS response from post operation
  getJobs(): void {
    this.jobService.getJobs()
      .subscribe(res => {
        this.jobsArray = res;
      }, err => {
        this.notificationService.showError(err);
      });
  }

}
